import {
  getRequest,
  postRequest,
} from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";
import { API_URLS } from "../../../constants";

const { BRAND } = API_URLS;

//Getting brand locations by brandid
const getBrandRestaurants = (brandId, body) =>
  postRequest(`${BRAND.STORES}?brandId=${brandId}`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

//Getting general data like name and id etc for brand profile by brandid
const getBrandProfile = (id) =>
  getRequest(`${BRAND.BRAND_PROFILE}?brandId=${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

//Gets brand locations by brand id
const getBrandLocationsByBrandId = (id) =>
  getRequest(`${BRAND.GET_STORE}/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

//Gets brand by brand id
const getBrandByBrandId = (brandId) =>
  getRequest(`${BRAND.BASE}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

//Exporting functions for other files
export const brandProfileService = {
  getBrandProfile,
  getBrandByBrandId,
  getBrandRestaurants,
  getBrandLocationsByBrandId,
};
